<template>
  <div>
    <NuxtLayout name="default">
      <div>
        <NuxtPage></NuxtPage>
      </div>
    </NuxtLayout>
  </div>
</template>
<script setup>
useHead({
  title: process.env.npm_package_name || '',
  viewport: 'width=device-width,initial-scale=1,maximum-scale=1 ',
  charset: 'utf-8',
  meta: [
    {
      name: 'viewport',
      content:
        'width=device-width,initial-scale=1.0,maximum-scale=1.0,minimum-scale=1.0,user-scalable=no,viewport-fit=cover',
    },
    {
      hid: 'description',
      name: 'description',
      content: process.env.npm_package_description || '',
    },
  ],
  link: [{ rel: 'icon', type: 'image/x-icon', href: '/favicon.ico' }],
})
</script>
<style type="text/css">
ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none;
}
</style>
